import * as Yup from "yup";

export const initialValues = {
  lowestBaseSalary: 0,
  highestBaseSalary: 0,
  lowestSubvention: 0,
  highestSubvention: 0,
  insurancePersonContributionRate: 0,
  corporateContributionRate: 0,
};

const SocialSecurityContributionSchema = Yup.object().shape({
  lowestBaseSalary: Yup.string().required("Please enter your lowest base salary."),
  highestBaseSalary: Yup.string().required("Please enter your highest base salary."),
  lowestSubvention: Yup.string().required("Please enter your lowest subvention."),
  highestSubvention: Yup.string().required("Please enter your highest subvention."),
  insurancePersonContributionRate: Yup.string().required("Please enter your insurance person contribution rate."),
  corporateContributionRate: Yup.number().required(
    "Please enter your corporate contribution rate."
  ),
});

export default SocialSecurityContributionSchema;
